import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ReservationCompareStore } from '../service/reservation-compare-store';
import { ReservationCompare } from '../models/reservation-compare';
import { LogService } from '../../shared/log/log.service';

@Injectable()
export class ReservationCompareResolver implements Resolve<any> {
  private previousRoute: string = null;

  constructor(private reservationCompareStore: ReservationCompareStore,
              private translateService: TranslateService,
              private logService: LogService,
              private router: Router) {
    // This code is required in order to know the previous route in resolve.
    // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
    // to the route, then NavigationEnd happens.
    this.router.events
      .filter(e => e instanceof NavigationEnd)
      .subscribe((e: NavigationEnd) => {
        this.previousRoute = e.url;
      });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<ReservationCompare>> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.RESERVATION_COMPARE'));
    }

    // Reset the filters unless the last route was reservations summary or detail
    // Note that this resolve happens before the NavigationEnd event for the route we're about to go to,
    // so we can find the last route that was navigated to successfully by checking the last NavigationEnd event.
    if (this.previousRoute && !this.previousRoute.includes(`/${id}/reservations`)) {
      this.reservationCompareStore.resetStatusCodes();
    }

    if (eventPartyId) {
      return this.reservationCompareStore.getReservationsByParty(route.params['id'], eventPartyId);
    } else {
      return this.reservationCompareStore.getReservations(route.params['id']);
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation.compare.resolver.ts